var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "system-user-list" }, [
    _c("div", { staticClass: "page-title bottom-line" }, [
      _vm._v(" " + _vm._s(_vm.$t("data.exchange_rate")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "filter-container" },
      [
        _c(
          "el-button",
          {
            staticClass: "search-btn",
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.getList },
          },
          [_vm._v(_vm._s(_vm.$t("components.refresh")))]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.base_currency"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(" " + _vm._s(scope.row.base_currency) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("data.quote_currency"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(" " + _vm._s(scope.row.quote_currency) + " "),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("data.exchange_rate"),
                width: "300",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(" " + _vm._s(scope.row.exchange_rate)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.update_time"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(" " + _vm._s(scope.row.update_time) + " ")]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "right",
              margin: "10px",
              color: "#1D3A71",
              "font-size": "14px",
            },
          },
          [_vm._v("* " + _vm._s(_vm.$t("tips.exchange_rate_update_tip")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }